import { useEffect, useState } from 'react';

/**
 * `true` cuando el viewport es ≥1024px (el breakpoint `lg` de Tailwind). Reactivo:
 * se actualiza al cruzar el breakpoint (resize / rotación). Se usa para el layout de
 * bienvenida/auth en desktop, donde el comportamiento —no sólo el estilo— cambia
 * (el signup se muestra fijo y no se puede cerrar; ver ADR de la adaptación a desktop).
 */
const QUERY = '(min-width: 1024px)';

export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () =>
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia(QUERY).matches,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(QUERY);
    const onChange = () => setIsDesktop(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}

export default useIsDesktop;
